import React from "react";
import {
    CameraHoc, CloseReplyHoc, ContactHoc, DocumentIconHoc, LocationHoc,	
    VideoIcon2Hoc, ChatAudioSender2Hoc, ChatAudioRecorderDarkHoc
} from '../../../../../../assets/images';
import {
    displayNameFromRoster, getDisplayNameFromGroup,
    isSingleChat, isTextMessage
} from '../../../../../../Helpers/Chat/ChatHelper';
import { isLocalUser } from "../../../../../../Helpers/Chat/User.js";
import GoogleMapMarker from "../Common/GoogleMapMarker.js";
import ImageComponent from '../../../../../../Components/Common/ImageComponent.js';
import { getThumbBase64URL, millisToMinutesAndSeconds } from "../../../../../../Helpers/Utility";

const maximumCaptionLimit = 220;

const ImageReply = React.memo(({ file_url }) => {
    const token = getFromLocalStorageAndDecrypt('token');
    return (
        <ImageComponent
            chatType={null}
            temporary={false}
            classProps={{ 'webchat-conver-image': true }}
            userToken={token}
            imageToken={file_url}
            imageType={"chatimages"}
        />
    )
})

const VideoReply = React.memo(({ thumb_image }) => {
    const responseURL = `data:image/png;base64,${thumb_image}`;
    return (
        <img className='webchat-conver-image' src={responseURL} alt="chat-img" />
    )
});

const filterProfileFromRoster = (rosterData, messageFrom) => {
    const userDetails = rosterData.data.find((profile) => {
        const rosterJid = (profile.username) ? profile.username : profile.userId;
        return messageFrom === rosterJid
    });
    return displayNameFromRoster(userDetails, messageFrom)
}

const ReplyToMessage = React.memo((props) => {
    const { rosterData, closeReplyAction, replyMessage, groupMemberDetails, jid = "" , clearReplay = false } = props
    const { fromUserId, msgBody: messageContent = {}, message: groupchatMessage = {}, publisherId, chatType } = replyMessage;
    let callRefSpan = React.createRef();
    let messageFrom = isSingleChat(chatType) ? fromUserId : publisherId;
    const { message = "", message_type = "", media = {},
        location: { latitude, longitude } = {},
        contact: { name } = {} } = messageContent || groupchatMessage


    const { fileName, duration, caption = "", audioType, thumb_image } = media;
    const [overflowActive, setOverflowActive] = React.useState(false)
    // React.useEffect(() => {
    //     props.popUpState({
    //         name: 'smileyPopUp',
    //         smileyPopUp: {
    //             active: true
    //         }
    //     })
    //     return () => {
    //         props.popUpState({
    //             name: 'smileyPopUp',
    //             smileyPopUp: {
    //                 active: false
    //             }
    //         })
    //     }
    // }, [])

    const getDisplayName = () => {
        if (isLocalUser(messageFrom)) return 'You'

        if (isSingleChat(chatType)) {
            return filterProfileFromRoster(rosterData, messageFrom)
        }
        const { nameToDisplay: senderName } = getDisplayNameFromGroup(messageFrom, groupMemberDetails);
        return senderName;
    }

    const getReplyCaption = (mediaCaption) => mediaCaption.length > maximumCaptionLimit ? mediaCaption.substring(0, maximumCaptionLimit).concat('...') : mediaCaption;

    const isEllipsisActive = (e) => {
        return e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth;
    }
    React.useEffect(()=>{
        if(!clearReplay) closeReplyAction(jid)
    },[clearReplay])

    React.useEffect(() => {
        setOverflowActive(isEllipsisActive(callRefSpan));
    }, [callRefSpan]);
    return (
        <React.Fragment>
            <div id="reply-block-bottom" className="reply-block-bottom">
                <div className="reply-container">
                    <div className={`reply-text-message ${isTextMessage(message_type) ? "text-message" : ""}`}>
                        <span className="sender-name" >{getDisplayName() ? getDisplayName() : "You"}</span>
                        {isTextMessage(message_type) && <span ref={element => callRefSpan = element} className="sender-sends"><span dangerouslySetInnerHTML={{ __html: getReplyCaption(message) }} ></span></span>}{overflowActive ? "..." : ""}
                        {message_type === 'image' && <span className="sender-sends"><span><i className="chat-camera"><CameraHoc viewBox="0 0 20 20"/></i><span>{caption === '' ? "Photo" : getReplyCaption(caption)}</span></span></span>}
                        {message_type === 'video' && <span className="sender-sends">
                            <span>
                                <i className="chat-video">
                                    <VideoIcon2Hoc viewBox="0 0 20.001 20" />
                                </i>
                                {caption === '' ? `${millisToMinutesAndSeconds(duration)} Video` : getReplyCaption(caption)}
                            </span> </span>
                        }
                        {message_type === 'audio' && < span className="sender-sends">
                            <span><i className="chat-audio">
                                {audioType !== "recording" ? <ChatAudioSender2Hoc viewBox="0 0 35 35" /> : <ChatAudioRecorderDarkHoc viewBox="0 0 13.249 19.873" />}
                            </i><span>{millisToMinutesAndSeconds(duration)}{" Audio "}
                                </span></span>
                        </span>}
                        {message_type === 'file' && <span className="sender-sends"><span><i className="chat-docu"><DocumentIconHoc viewBox = "0 0 20 20"/> </i><span>{fileName} </span></span></span>}
                        {message_type === 'contact' && <span className="sender-sends"><span><i className="chat-contact"><ContactHoc /></i><span> {name}</span></span></span>}
                        {message_type === 'location' && <span className="sender-sends"><span><i className="chat-location"><LocationHoc /></i><span> Location</span></span></span>}
                    </div>
                    {!isTextMessage(message_type) &&
                        <div className="reply-message-type">
                            {message_type === 'image' &&
                                <img src={getThumbBase64URL(thumb_image)} className={`webchat-conver-image ${caption === "" ? "no-caption" : ""}`} alt="reply message" />
                            }
                            {message_type === 'audio' && ""}
                            {message_type === 'video' && <img src={getThumbBase64URL(thumb_image)} className={`webchat-conver-image ${caption === "" ? "no-caption" : ""}`} alt="reply message" />}
                            {message_type === 'file' && ""
                                // Need to implement for ppt and pdf
                                // <span className="webchat-conver-image"><i className="doc-icon"><img alt="file" src={placeholder} /></i></span>
                            }
                            {message_type === 'contact' &&
                                <span className="webchat-conver-image"></span>
                            }
                            {message_type === 'location' && <span className="webchat-conver-image"><GoogleMapMarker latitude={latitude} longitude={longitude} /></span>}
                        </div>
                    }
                </div>
                <div className="RemoveReplay">
                    <i><CloseReplyHoc onClick={() => closeReplyAction(jid)} /></i>
                </div>
            </div>

        </React.Fragment>
    )
})

export default ReplyToMessage;
